import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f0bc40b2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "sidebar-menu" }
const _hoisted_2 = { class: "sidebar-menu__list" }
const _hoisted_3 = { class: "sidebar-menu__item" }
const _hoisted_4 = { class: "sidebar-menu__item" }
const _hoisted_5 = { class: "sidebar-menu__item" }
const _hoisted_6 = { class: "sidebar-menu__item" }


import { router } from "@/app/providers";


export default /*#__PURE__*/_defineComponent({
  __name: 'SidebarMenu',
  props: {
    isSidebarOpen: { type: Boolean }
  },
  emits: ["update:isSidebarOpen"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const toogleMenu = () => {
  emit("update:isSidebarOpen", !props.isSidebarOpen);
};

const scrollTo = (id: string) => {
  if (router.currentRoute.value.path !== "/") {
    router.replace({ name: "home", hash: "#" + id });
    // return;
  }

  setTimeout(() => {
    scrollToElementWithOffset(id, 115);
  }, 100);

  toogleMenu();
};

const scrollToElementWithOffset = (elementId: string, offset: number) => {
  let element = document.getElementById(elementId);

  if (element) {
    let elementPosition = element.getBoundingClientRect().top;
    let start = window.pageYOffset;
    let startTime: any = null;

    const scrollAnimation = (currentTime: any) => {
      if (startTime === null) startTime = currentTime;

      let progress: any = currentTime - startTime;
      let easeInOutCubic = (progress: any) =>
        progress < 0.5
          ? 4 * progress ** 3
          : 1 - Math.pow(-2 * progress + 2, 3) / 2;

      let scrollTo = elementPosition - offset;
      window.scrollTo(0, start + scrollTo * easeInOutCubic(progress / 500));

      if (progress < 500) {
        requestAnimationFrame(scrollAnimation);
      }
    };

    requestAnimationFrame(scrollAnimation);
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("ul", _hoisted_2, [
      _createElementVNode("li", _hoisted_3, [
        _createElementVNode("div", {
          class: "sidebar-menu__link",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (scrollTo('how')))
        }, "1x_How")
      ]),
      _createElementVNode("li", _hoisted_4, [
        _createElementVNode("div", {
          class: "sidebar-menu__link",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (scrollTo('technology')))
        }, " 2x_Technology ")
      ]),
      _createElementVNode("li", _hoisted_5, [
        _createElementVNode("div", {
          class: "sidebar-menu__link",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (scrollTo('do-more')))
        }, " 3x_Do_more ")
      ]),
      _createElementVNode("li", _hoisted_6, [
        _createElementVNode("div", {
          class: "sidebar-menu__link",
          onClick: _cache[3] || (_cache[3] = ($event: any) => (scrollTo('get-in-touch')))
        }, " 4x_Get_in_touch ")
      ])
    ])
  ]))
}
}

})